const DEV_REGISTRATION_URL = 'https://placeme.dataplace.tech/auth/register'
const PROD_REGISTRATION_URL = 'https://platform.dataplace.ai/auth/register'

const isProduction = process.env.NX_FIREBASE_ENVIRONMENT === 'PROD' || process.env.NX_ENV === 'PROD'

export const REGISTRATION_URL = isProduction ? PROD_REGISTRATION_URL : DEV_REGISTRATION_URL

export const isLegacySignUpPath = (pathname: string): boolean => /^\/(?:auth\/)?sign-up(?:\/|$)/.test(pathname)
